module.exports = __webpack_public_path__ + "img/galeria-animales-2.78023536.jpg";